import { render, staticRenderFns } from "./h3-block.vue?vue&type=template&id=97084932&"
import script from "./h3-block.vue?vue&type=script&lang=js&"
export * from "./h3-block.vue?vue&type=script&lang=js&"
import style0 from "./h3-block.vue?vue&type=style&index=0&id=97084932&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports